import React,{Component} from 'react';
import './Steps.css';

class Steps extends Component {
  constructor(props) {
    super(props);
  }

  handleStepClick = (index) => {
    const {onStepClick} = this.props;
    if(onStepClick) {
      this.props.onStepClick(index+2);
    }
  }

  render() {
    let steps = null;
    if(this.props.steps.length > 0) {
      steps = (this.props.steps.map((step, index) => {
        return (
        <div  key = {index} 
        className={(this.props.currentStep === (index + 1)) ? "step-wrapper current" : 
        ((this.props.currentStep > (index + 1)) ? "step-wrapper done" : "step-wrapper")}
        style={{cursor : this.props.onStepClick ? 'pointer' : 'initial'}}
        onClick={() => {this.handleStepClick((index))}}>
          <div className="step">
            {index+1}. {step}
          </div>
       </div>)
       }))
    }
    return(
      <div id="steps"  className="row clear">
        {steps} 
      </div>
    )
  }
}

export default Steps;